module.exports = __webpack_public_path__ + "img/emptyCart.6c129604.png";